import React, { useState } from "react";
import "./Section4.css";
import Icons from "../../../../../Config/Images";

const Section4 = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is Zabali.co?",
      answer:
        "Zabali.co is an innovative platform designed for jewelry professionals, offering a smarter way to connect, explore, and grow in the jewelry trading industry.",
    },
    {
      question: "What services does Zabali provide?",
      answer:
        "Zabali offers direct sourcing of jewelry designs, eliminating middlemen, and provides a curated collection of handpicked designs. Additionally, the platform ensures lightning-fast delivery to support your business needs.",
    },
    {
      question: "How can Zabali benefit my jewelry business?",
      answer:
        "By partnering with Zabali, you gain access to authentic jewelry designs directly from the source, curated collections tailored for your clientele, and efficient delivery services, all aimed at enhancing your business operations and profitability.",
    },
    {
      question: "Who can join Zabali?",
      answer:
        "Zabali is tailored for jewelry professionals, including retailers, wholesalers, and designers seeking innovative solutions in jewelry trading.",
    },
    {
      question: "How do I get started with Zabali?",
      answer:
        "Visit our website at www.zabali.co to explore our services. For personalized assistance, reach out to our team through the contact information provided on the site.",
    },
    
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="section-4">
      <div className="section-4-header">
        <p className="section-4-header-para">Zabali's FAQ Section</p>
        <p className="section-4-header-content">
          We’ve compiled answers to some of the most commonly asked questions to
          make your experience seamless.
          <br />
          If you can’t find what you’re looking for here, feel free to reach out
          to our support team.
        </p>
      </div>
      <div className="f-a-q-div">
        {faqData.map((faq, index) => (
          <div key={index} className="f-a-q-card">
            <div className="f-a-q-header" onClick={() => toggleFAQ(index)}>
              <p className="f-a-q-para">{faq.question}</p>
              <img
                src={
                  activeIndex === index ? Icons.minus_img : Icons.vectorDownIcon
                }
                alt="toggle icon"
              />
            </div>
            {activeIndex === index && (
              <p className="f-a-q-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Section4;
